import { Box, Skeleton, Theme, useMediaQuery } from '@mui/material';

import { styles as episodeDetailsStyles } from '@/containers/EpisodeDetails';

export const EpisodeSkeleton = () => {
  const isSmDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  return (
    <Box
      sx={
        isSmDown ? episodeDetailsStyles.rootMobile : episodeDetailsStyles.root
      }>
      <Box sx={episodeDetailsStyles.leftColumn}>
        <Skeleton variant="rounded" height={260} />
        <Box>
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} />
          ))}
        </Box>
        <Skeleton variant="rounded" height={200} />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant="rounded" width="45%" height={100} />
          <Skeleton variant="rounded" width="45%" height={100} />
          <Skeleton variant="rounded" width="45%" height={100} />
        </Box>
      </Box>
      <Box sx={episodeDetailsStyles.rightColumn}>
        <Skeleton variant="rounded" height={260} sx={{ borderRadius: 4 }} />
        <Box>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={80} sx={{ mt: 2 }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
